
const digest = 'b75fc8b0341438f232a1b4a65039a82b084817d63ce64652c0c5cb95d7464376';
const classes = {"title":"_title_1l3t9_1","subtitle":"_subtitle_1l3t9_5","inline":"_inline_1l3t9_11","input":"_input_1l3t9_18"};
const css = `._title_1l3t9_1 {
  font-weight: 600;
}

._subtitle_1l3t9_5 {
  font-size: 14px;
  color: #b1b1b1;
  font-style: italic;
}

._inline_1l3t9_11 {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;
  font-weight: 600;
}
._inline_1l3t9_11 ._input_1l3t9_18 {
  flex: 1;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  